import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consulta-documento',
  templateUrl: './consulta-documento.component.html',
  styleUrls: ['./consulta-documento.component.scss']
})
export class ConsultaDocumentoComponent implements OnInit {

  optionsmes: Array<any> = [];
  optionsYear: Array<any> = [];
  optionsTipoDoc: Array<any> = [];

  constructor() { }

  ngOnInit() {
    this.optionsTipoDoc = [
      { value: "1", label: "Factura" },
      { value: "2", label: "Boleta" },
      { value: "3", label: "Nota de crédito" }
    ];
     this.optionsmes = [
      { value: "1", label: "Mes 1" },
      { value: "2", label: "Mes 2" },
      { value: "3", label: "Mes 3" }
    ];
    this.optionsYear = [
      { value: "1", label: "Año 1" },
      { value: "2", label: "Año 2" },
      { value: "3", label: "Año 3" }
    ];
  }

}
